module.exports = __webpack_public_path__ + "img/japan-ovarian-cancer-female.b615ca2e.png";